export const NAME = 'creatCase';